import { Fragment } from "react";
import { Redirect } from "react-router-dom";
import { Dropdown, DropdownButton } from "react-bootstrap";
import SVG from "react-inlinesvg";
import Select from "react-select";
import Swal from "sweetalert2";
import printJS from "print-js";
import * as Excel from "exceljs";
import { saveAs } from "file-saver";
import { Document, Page, Text, View, StyleSheet, pdf, Font } from "@react-pdf/renderer";
import * as actions from "../app/modules/DefinitionActions/_redux/timetable/TimeTableAction";
import { toAbsoluteUrl } from "../_metronic/_helpers";

/** Sistemde Tanımlı Yetkileri İfade Eder */
export const Authority = {
  List: 1,
  Add: 2,
  Edit: 3,
  Delete: 4,
  Export: 5,
  Report: 6
};

/** Kullanıcı Türlerini İfade Eder */
export const UserType = {
  System: 0,
  Personnel: 1,
  Teacher: 2,
  Student: 3,
  Parent: 4
};

/** Duyuru Gönderilecek Kişilerin Ait Oldukları Grupları İfade Eder */
export const NoticeReceipentType = {
  Personnel: 0,
  Teacher: 1,
  Parent: 2,
  Father: 3,
  Mother: 4,
  Student: 5,
  AdvisorStudent: 6,
  AdvisorParent: 7
};

/** Sınıf Düzeylerini İfade Eder */
export const GradeLevel = {
  Kindergarten: 0,
  Preschool: 1,
  ElementarySchool: 2,
  MiddleSchool: 3,
  HighSchool: 4,
  Graduate: 5,
  Adult: 6
};

/** Ders Programı Türlerini İfade Eder */ 
export const TimetableType = {
  Both: 0,
  Section: 1,
  Teacher: 2
};

/** Kitap Kategorilerini İfade Eder */
export const BookCategory = {
  ReferenceBooks: 0,
  Computer: 1,
  ScienceEngineering: 2,
  ChildrenBooks: 3,
  Magazine: 4,
  Other: 5,
  Literature: 6,
  EntertainmentHumor: 7,
  Hobby: 8,
  PersonalDevelopment: 9,
  Culture: 10,
  Music: 11,
  Politics: 12,
  Art: 13,
  CinemaTheatre: 14,
  History: 15,
  TourismTravel: 16
};

/** Öğrenci Kitap Raporu Türlerini İfade Eder */
export const BookReportType = {
  Standard: 0,
  BookAndPageNumber: 1,
  Monthly: 2
};

/** Akrabalıkları İfade Eder */
export const Relationship = {
  Self: 0,
  Father: 1,
  Mother: 2,
  Other: 3
};

/** Fatura Türlerini İfade Eder */
export const InvoiceType = {
  Person: 0,
  Company: 1
};

/** Öğrenci Yoklama Durumlarını İfade Eder */
export const AttendanceStatus = {
  Here: 0,
  Absent: 1,
  Awl: 2,
  Sick: 3,
  OnDuty: 4,
  Latecomer: 5
};

/** Ders Konusu Anlatım Durumlarını İfade Eder */
export const SubjectStatus = {
  Started: 0,
  Continued: 1,
  Completed: 2
}

/** Karne Durumlarını İfade Eder */
export const ReportStatus = {
  Preparing: 0,
  Printing: 1,
  Printed: 2
}

/** Ödev Değerlendirilme Durumlarını İfade Eder */
export const HomeworkStatus = {
  DidCompletely: 0,
  Missed: 1,
  DidNotDo: 2,
  NotEvaluated: 3,
  DidNotCome: 4,
  DidNotBring: 5,
  DidLate: 7
};

/** Belli Bir İşlemin Sonuç Seçeneklerini İfade Eder */
export const Result = {
  Success: "success",
  Warning: "warning",
  Error: "error",
  Unauthenticated: "unauthenticated",
  Unauthorized: "unauthorized"
};

/** Bugünü İfade Eder */
export const today = new Date().toISOString().split('T')[0]; 

/** Haftanın Günlerini İfade Eder */
export const Days = ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"];

/** Haftanın Günlerinin İngilizce Karşılıklarını İfade Eder */
export const DaysInEnglish = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

/** Yılın Aylarını İfade Eder */
export const Months = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

/** Sistemde Tanımlı Yetkileri İfade Eder */
export const Authorities = [
  { id: Authority.List, name: "List", definition: "Listeleme" },
  { id: Authority.Add, name: "Add", definition: "Ekleme" },
  { id: Authority.Edit, name: "Edit", definition: "Düzenleme" },
  { id: Authority.Delete, name: "Delete", definition: "Silme" },
  { id: Authority.Export, name: "Export", definition: "Dışa Aktarma" },
  { id: Authority.Report, name: "Report", definition: "Raporlama" }
];

/** Okul Karnesi Modüllerini İfade Eder */
export const SchoolReportModules = [
  { id: 0, module: "Devamsızlık Durumu Toplam"},
  { id: 1, module: "Devamsızlık Durumu Liste"},
  { id: 6, module: "Şube Duyuruları"},
  { id: 7, module: "Okul Duyuruları"},
  { id: 8, module: "Faaliyetler"},
];

/** Onay Css Sınıf (Class) larını İfade Eder */
export const ConfirmationCssClasses = { true: "success", false: "danger" };

/** Onay Seçeneklerini İfade Eder */
export const ConfirmationTitles = { true: "Evet", false: "Hayır" };

/** ... İfade Eder */
export const StatusCssClasses = { true: "success", false: "danger" };

/** ... İfade Eder */
export const StatusTitles = { true: "Aktif", false: "Pasif" };

/** ... İfade Eder */
export const ActionResultTitles = { true: "Başarı", false: "Hata" };

/** ... İfade Eder */
export const NoticeStatusTitles = { true: "Gönderildi", false: "Beklemede" };

/** ... İfade Eder */
export const NoticeReadingTitles = { true: "Okundu", false: "Okunmadı" };

/** Ödev Değerlendirilme Seçeneklerini İfade Eder */
export const HomeworkStatusTitles = { true: "Değerlendirildi", false: "Değerlendirilmedi" };

/** Log Level Css Sınıf (Class) larını İfade Eder */
export const LogLevelCssClasses = {
  "Verbose": "primary",
  "Debug": "",
  "Information": "info",
  "Warning": "warning",
  "Error": "danger",
  "Fatal": "dark"
};

/** Karne Durumu Css Sınıf (Class) larını İfade Eder */
export const SchoolReportStatusCssClasses = {
  0: "primary",
  1: "info",
  2: "success"
};

/** Karne Durumu Seçeneklerini İfade Eder */
export const SchoolReportStatusTitles = {
  0: "Karne Hazırlanıyor",
  1: "Karne Basılıyor",
  2: "Karne Basıldı"
};

/** ... İfade Eder */
export const FilterOptions = [
  { label: "Tümü" }
];

/** ... İfade Eder */
export const DropdownOptions = [
  { value: null, label: "Seçiniz" }
];

/** Onay Seçeneklerini İfade Eder */
export const ConfirmationOptions = [
  { label: "Tümü" },
  { value: true, label: "Evet" },
  { value: false, label: "Hayır" }
];

/** Kayıt Durumu Seçeneklerini İfade Eder */
export const StatusOptions = [
  { label: "Tümü" },
  { value: true, label: "Aktif" },
  { value: false, label: "Pasif" }
];

/** HTTP Metod Seçeneklerini İfade Eder */
export const HTTPMethodOptions = [
  { label: "Tümü" },
  { value: "GET", label: "GET" },
  { value: "POST", label: "POST" },
  { value: "DELETE", label: "DELETE" }
];

/** Log Level Seçeneklerini İfade Eder */
export const LogLevelOptions = [
  { label: "Tümü" },
  { value: "Verbose", label: "Verbose" },
  { value: "Debug", label: "Debug" },
  { value: "Information", label: "Information" },
  { value: "Warning", label: "Warning" },
  { value: "Error", label: "Error" },
  { value: "Fatal", label: "Fatal" }
];

/** İşlem Sonucu Seçeneklerini İfade Eder */
export const ActionResultOptions = [
  { label: "Tümü" },
  { value: true, label: "Başarı" },
  { value: false, label: "Hata" }
];

/** Duyuru Gönderim Durumu Seçeneklerini İfade Eder */
export const NoticeStatusOptions = [
  { label: "Tümü" },
  { value: true, label: "Gönderildi" },
  { value: false, label: "Beklemede" }
];

/** Duyuru Okunma Durumu Seçeneklerini İfade Eder */
export const NoticeReadingOptions = [
  { label: "Tümü" },
  { value: true, label: "Okundu" },
  { value: false, label: "Okunmadı" }
];

/** Duyuru Gönderilecek Kişi Seçeneklerini İfade Eder */
export const NoticeReceipentTypeOptions = [
  { value: 0, label: "Personel" },
  { value: 1, label: "Öğretmen" },
  { value: 2, label: "Veli" },
  { value: 3, label: "Baba" },
  { value: 4, label: "Anne" },
  { value: 5, label: "Öğrenci" }
];

/** Duyuru Gönderilecek Öğrenci Seçeneklerini İfade Eder */
export const StudentReceipentTypeOptions = [
  { value: 4, label: "Öğrenci" },
  { value: 1, label: "Veli" },
  { value: 5, label: "Danışman Öğrenci" },
  { value: 6, label: "Danışman Öğrenci Velisi" },
  { value: 7, label: "Sınıf" }
];

/** Kullanıcı Türü Seçeneklerini İfade Eder */
export const UserTypeOptions = [
  { value: 0, label: "Sistem" },
  { value: 1, label: "Personel" },
  { value: 2, label: "Öğretmen" },
  { value: 3, label: "Öğrenci" },
  { value: 4, label: "Veli" }
];

/** Sınıf Düzeyi Seçeneklerini İfade Eder */
export const GradeLevelOptions = [
  { value: 0, label: "Kreş" },
  { value: 1, label: "Anaokulu" },
  { value: 2, label: "İlkokul" },
  { value: 3, label: "Ortaokul" },
  { value: 4, label: "Lise" },
  { value: 5, label: "Mezun" },
  { value: 6, label: "Yetişkin" }
];

/** Sınıf Seçeneklerini İfade Eder */
export const GradeOptions = [
  { value: "Kreş", label: "Kreş" },
  { value: "Anaokulu", label: "Anaokulu" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "Mezun", label: "Mezun" },
  { value: "Yetişkin", label: "Yetişkin" }
];

/** Kitap Kategorisi Seçeneklerini İfade Eder */
export const BookCategoryOptions = [
  { value: 0, label: "Başvuru Kitapları" },
  { value: 1, label: "Bilgisayar" },
  { value: 2, label: "Bilim Mühendislik" },
  { value: 3, label: "Çocuk Kitapları" },
  { value: 4, label: "Dergi" },
  { value: 5, label: "Diğer" },
  { value: 6, label: "Edebiyat" },
  { value: 7, label: "Eğlence-Mizah" },
  { value: 8, label: "Hobi" },
  { value: 9, label: "Kişisel Gelişim" },
  { value: 10, label: "Kültür" },  
  { value: 11, label: "Müzik" },  
  { value: 12, label: "Politika ve Siyaset" },
  { value: 13, label: "Sanat" },
  { value: 14, label: "Sinema-Tiyatro" },
  { value: 15, label: "Tarih" },
  { value: 16, label: "Turizm-Gezi" }
];

/** Başvuru Kitapları Türü Seçeneklerini İfade Eder */
export const ReferenceBookTypeOptions = [
  { value: 0, label: "Albüm" },
  { value: 1, label: "Ansiklopedi" },
  { value: 2, label: "Atlas" },
  { value: 3, label: "Diğer" }
];

/** Bilgisayar Türü Seçeneklerini İfade Eder */
export const ComputerTypeOptions = [
  { value: 0, label: "Bilgisayar Kullanım" },
  { value: 1, label: "Grafik-Tasarım" },
  { value: 2, label: "İnternet" },
  { value: 3, label: "İşletim Sistemleri" },
  { value: 4, label: "Ofis Programları" },
  { value: 5, label: "Programlama Dilleri" },
  { value: 6, label: "Yazılım" }
];

/** Bilim Mühendislik Türü Seçeneklerini İfade Eder */
export const ScienceEngineeringTypeOptions = [
  { value: 0, label: "Bilim Adamları" },
  { value: 1, label: "Bilim Tarihi" },
  { value: 2, label: "Coğrafya" },
  { value: 3, label: "Matematik" },
  { value: 4, label: "Popüler Bilim" },
  { value: 5, label: "Teknik Kitaplar" },
  { value: 6, label: "Teknoloji" },
  { value: 7, label: "Uygulamalı Bilimler" }
];

/** Çocuk Kitapları Türü Seçeneklerini İfade Eder */
export const ChildrenBookTypeOptions = [
  { value: 0, label: "Temel Eser" },
  { value: 1, label: "12 + Yaş" },
  { value: 2, label: "7-12 Yaş" }
];

/** Dergi Türü Seçeneklerini İfade Eder */
export const MagazineTypeOptions = [
  { value: 0, label: "Öykü" },
  { value: 1, label: "Bilim" },
  { value: 2, label: "Sanat" }
];

/** Diğer Tür Seçeneklerini İfade Eder */
export const OtherTypeOptions = [
  { value: 0, label: "Astroloji" },
  { value: 1, label: "Astronomi" },
  { value: 2, label: "Atasözleri-Deyimler" },
  { value: 3, label: "Çevre-Doğa" },
  { value: 4, label: "Dilbilim" },
  { value: 5, label: "Enformasyon" },
  { value: 6, label: "Gençlik Kitapları" },
  { value: 7, label: "Güzel-Özlü Sözler" },
  { value: 8, label: "İletişim-Medya" },
  { value: 9, label: "Mitoloji" },
  { value: 10, label: "Dini Kitaplar" }
];

/** Edebiyat Türü Seçeneklerini İfade Eder */
export const LiteratureTypeOptions = [
  { value: 0, label: "Anı" },
  { value: 1, label: "Anlatı" },
  { value: 2, label: "Antoloji-Derleme" },
  { value: 3, label: "Armağan" },
  { value: 4, label: "Belgesel Roman" },
  { value: 5, label: "Bilim Kurgu" },
  { value: 6, label: "Deneme" },
  { value: 7, label: "Destan" },
  { value: 8, label: "Divan Edebiyatı" },
  { value: 9, label: "Doğu Klasikleri" },
  { value: 10, label: "Edebiyat Tarihi" },
  { value: 11, label: "Hikaye" },
  { value: 12, label: "Dünya Edebiyatı" },
  { value: 13, label: "Dünya Klasikleri" },
  { value: 14, label: "Türk Edebiyatı" },
  { value: 15, label: "Edebiyat Bilimi" },
  { value: 16, label: "Roman" },
  { value: 17, label: "Şiir" }
];

/** Cinsiyet Seçeneklerini İfade Eder */
export const SexOptions = [
  { value: 0, label: "Kadın" },
  { value: 1, label: "Erkek" }
];

/** Öğrenci Kitap Raporu Türü Seçeneklerini İfade Eder */
export const BookReportTypeOptions = [
  { value: 0, label: "Standart Rapor" },
  { value: 1, label: "Kitap ve Sayfa Sayısı" },
  { value: 2, label: "Aylık Kitap Okuma Raporu" }
];

/** Öğrenci Cinsiyet Seçeneklerini İfade Eder */
export const StudentSexOptions = [
  { value: 0, label: "Kız" },
  { value: 1, label: "Erkek" }
];

/** Kayıt Durumu Seçeneklerini İfade Eder */
export const RegistrationStatusOptions = [
  { value: 0, label: "Kesin Kayıt" },
  { value: 1, label: "Yaz Okulu" },
  { value: 2, label: "Ön Kayıt" }
];

/** Mezuniyet Türü Seçeneklerini İfade Eder */
export const GraduationTypeOptions = [
  { value: 0, label: "İlkokul" },
  { value: 1, label: "Ortaokul" },
  { value: 2, label: "Lise" },
  { value: 3, label: "Ön Lisans" },
  { value: 4, label: "Lisans" },
  { value: 5, label: "Yüksek Lisans" },
  { value: 6, label: "Doktora" }
];

/** Veli Seçeneklerini İfade Eder */
export const ParentOptions = [
  { value: 1, label: "Babası" },
  { value: 2, label: "Annesi" },
  { value: 3, label: "Diğer" }
];

/** Fatura Türü Seçeneklerini İfade Eder */
export const InvoiceTypeOptions = [
  { value: 0, label: "Şahıs" },
  { value: 1, label: "Şirket" }
];

/** Servis Kullanım Seçeneklerini İfade Eder */
export const TransportationUsageOptions = [
  { value: 0, label: "Kullanmayacak" },
  { value: 1, label: "Tam Servis" },
  { value: 2, label: "Sabah Servisi" },
  { value: 3, label: "Akşam Servisi" }
];

/** Evlilik Durumu Seçeneklerini İfade Eder */
export const MaritalStatusOptions = [
  { value: 0, label: "Evli" },
  { value: 1, label: "Bekar" },
  { value: 2, label: "Dul" }
];

/** Ön Görüşme Sonuç Seçeneklerini İfade Eder */
export const PreInterviewResultOptions = [
  { value: 0, label: "Olumlu" },
  { value: 1, label: "Olumsuz" },
  { value: 2, label: "Fiyattan Kaldı" },
  { value: 3, label: "Tekrar Aranacak" },
  { value: 4, label: "Kayıt Yapıldı" }
];

/** Görüşme Türü Seçeneklerini İfade Eder */
export const InterviewTypeOptions = [
  { value: 0, label: "Yüz Yüze" },
  { value: 1, label: "Telefonla" }
];

/** Sigorta Seçeneklerini İfade Eder */
export const InsuranceOptions = [
  { value: 0, label: "SSK" },
  { value: 1, label: "Bağkur" },
  { value: 2, label: "Emekli Sandığı" }
];

/** SMS Firması Seçeneklerini İfade Eder */
export const SmsFirmOptions = [
  { value: 0, label: "Mutlucell" },
  { value: 1, label: "Biotekno" },
  { value: 2, label: "CePosta" },
  { value: 3, label: "Öztek SMS" },
  { value: 6, label: "Vatan SMS" }
];

/** Öğrenci Yoklama Durumu Seçeneklerini İfade Eder */
export const AttendanceStatusOptions = [
  { value: 0, label: "Burada" },
  { value: 1, label: "Burada Değil" },
  { value: 2, label: "İzinli" },
  { value: 3, label: "Hasta" },
  { value: 4, label: "Nöbetçi" },
  { value: 5, label: "Geç Geldi" }
];

/**  Sınıf Yoklama Durumu Seçeneklerini İfade Eder */
export const SectionAttendanceStatusOptions = [
  { value: 0, label: "Alındı" },
  { value: 1, label: "Alınmadı" }
];

/** Öğrenci Devamsızlık Durumu Seçeneklerini İfade Eder */
export const AbsenteeismStatusOptions = [
  { value: 0, label: "Devamsızlık Yok" },
  { value: 1, label: "Tam Gün Yok" },
  { value: 2, label: "Yarım Gün Yok" },
  { value: 3, label: "İzinli" },
  { value: 4, label: "Raporlu/Sevkli" },
  { value: 5, label: "Faaliyet" },
  { value: 6, label: "Nöbetçi" },
  { value: 7, label: "Geç Geldi" }
];

/** Karne Durumu Seçeneklerini İfade Eder */
export const ReportStatusOptions = [
  { label: "Tümü" },
  { value: 0, label: "Karne Hazırlanıyor" },
  { value: 1, label: "Karne Basılıyor" },
  { value: 2, label: "Karne Basıldı" }
];

/** Ders Konusu Anlatım Durumu Seçeneklerini İfade Eder */
export const SubjectStatusOptions = [
  { value: 0, label: "Başlandı" },
  { value: 1, label: "Devam Ediyor" },
  { value: 2, label: "Tamamlandı" }
];

/** Ödev Türü Seçeneklerini İfade Eder */
export const HomeworkTypeOptions = [
  { value: 0, label: "Günlük Ödev" },
  { value: 1, label: "Performans Ödevi" },
  { value: 2, label: "Proje Ödevi" }
];

/** Branş Veya Danışman Öğretmen Seçeneklerini İfade Eder */
export const BranchAdvisorOptions = [
  { label: "Tümü" },
  { value: "Branş", label: "Branş" },
  { value: "Danışman", label: "Danışman" }
];

/** Ödev Değerlendirilme Durumu Seçeneklerini İfade Eder */
export const HomeworkStatusOptions = [
  { label: "Tümü" },
  { value: true, label: "Değerlendirildi" },
  { value: false, label: "Değerlendirilmedi" }
];

/** Ödev Değerlendirme Seçeneklerini İfade Eder */
export const HomeworkEvaluationOptions = [
  { value: 0, label: "Tam Yaptı" },
  { value: 1, label: "Eksik Yaptı" },
  { value: 2, label: "Yapmadı" },
  { value: 3, label: "Değerlendirilmedi" },
  { value: 4, label: "Gelmedi" },
  { value: 5, label: "Ödevi Getirmedi" },
  { value: 7, label: "Geç Yaptı" }
];

/** ... */
export function getDateFormat(date) {
  return date.split("-")[2] + "-" + date.split("-")[1] + "-" + date.split("-")[0];
}

/** ... */
export function redirectToPages(type) {
  if (type === Result.Unauthorized) return <Redirect to="/yetkisizlik" />;
  if (type === Result.Error) return <Redirect to="/sayfa-bulunamadi" />;
}

/** ... Yetkileri Elde Eder */
export function getAuthorities(authorities) {
  return {
    isAdditionAuthorized: authorities && authorities.includes(Authority.Add),
    isEditionAuthorized: authorities && authorities.includes(Authority.Edit),
    isDeletionAuthorized: authorities && authorities.includes(Authority.Delete),
    isExportationAuthorized: authorities && authorities.includes(Authority.Export)
  };
}

// ...
export function noUserGroupAlert() {
  Swal.fire({
    icon: "warning",
    title: "Kullanıcı Grubu Alanı Boş Geçilemez. Lütfen Kontrol Ediniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

// ...
export function noUserAlert() {
  Swal.fire({
    icon: "warning",
    title: "Kullanıcı Alanı Boş Geçilemez. Lütfen Kontrol Ediniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

// ...
export function noReceipentTypeAlert() {
  Swal.fire({
    icon: "warning",
    title: "Lütfen Bir Kişi Türü Seçiniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

// ...
export function noReceipentAlert() {
  Swal.fire({
    icon: "warning",
    title: "Lütfen Kişilerden En Az 1 Alıcı Seçiniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

// ...
export function noFileAlert() {
  Swal.fire({
    icon: "warning",
    title: "Yüklenecek Dosya Bulunmadı. Lütfen Kontrol Ediniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

/** */
export function nonXmlFormatAlert() {
  Swal.fire({
    icon: "warning",
    title: "Yüklenen Dosya Uygun Xml Dosyası Formatında Değildir. Lütfen Kontrol Ediniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

/** */
export function missingDataAlert() {
  Swal.fire({
    icon: "warning",
    title: "Aktarım İçin Yeterli Veri Bulunamadı. Dosya Oluşturulurken Hata Olmuş Olabilir. Lütfen Tekrar Deneyiniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

/** */
export function nonExcelFormatAlert() {
  Swal.fire({
    icon: "warning",
    title: "Yüklenen Dosya Uygun Excel Dosyası Formatında Değildir. Lütfen Kontrol Ediniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

// ...
export function noRecordsAlert() {
  Swal.fire({
    icon: "warning",
    title: "Lütfen Kayıt Seçiniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

// ...
export function emptyTermOrSemesterAlert() {
  Swal.fire({
    icon: "warning",
    title: "Eğitim Yılı Veya Dönemi Alanları Boş Geçilemez. Lütfen Kontrol Ediniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

// ...
export function noTableIdAlert(tableType) {
  const title = tableType === TimetableType.Section ? "Lütfen Bir Sınıf Seçiniz!" :
                tableType === TimetableType.Teacher ? "Lütfen Bir Öğretmen Seçiniz!" : "";

  Swal.fire({
    icon: "warning",
    title: title,
    timer: 2500,
    showConfirmButton: false
  });
}

/** ... */
export function emptyInputAlert() {
  Swal.fire({
    icon: "warning",
    title: "Zorunlu Alanlar Boş Geçilemez. Lütfen Kontrol Ediniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

/** ... İfade Eder */
export function nonPositiveModuleOrderAlert() {
  Swal.fire({
    icon: "warning",
    title: "Seçilen Bir Modülün Sırası 0 dan Büyük Bir Sayı Olmalıdır. Lütfen Kontrol Ediniz!",
    timer: 2500,
    showConfirmButton: false
  });
}

/** */
export function deletionAlert() {
  return Swal.fire({
    icon: "warning",
    title: "Silmek İstediğinize Emin misiniz?",
    text: "İlgili kayıt(lar) sistemden silinecektir.",
    showCancelButton: true,
    confirmButtonText: "Evet",
    cancelButtonText: "Hayır",
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
  });
}

/** */
export function allTimetableDeletionAlert() {
  return Swal.fire({
    icon: "warning",
    title: "Silmek İstediğinize Emin misiniz?",
    html: "Seçilen yıl ve dönemdeki <b>tüm ders programı</b> silinecektir.",
    showCancelButton: true,
    confirmButtonText: "Evet",
    cancelButtonText: "Hayır",
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
  });
}

/** */
export function removalAlert(text) {
  return Swal.fire({
    icon: "warning",
    title: "Çıkarmak İstediğinize Emin misiniz?",
    text: text,
    showCancelButton: true,
    confirmButtonText: "Evet",
    cancelButtonText: "Hayır",
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33'
  });
}

/** */
export function attendanceDeletionAlert() {
  return Swal.fire({
    icon: "warning",
    title: "Silmek İstediğinize Emin misiniz?",
    html: "Mevcut sınıf yoklaması sistemden silinecektir.",
    showCancelButton: true,
    confirmButtonText: "Evet",
    cancelButtonText: "Hayır",
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
  });
}

/** */
export function resultAlert(type, message) {
  if (type !== Result.Unauthenticated) {
    Swal.fire({
      icon: type === Result.Unauthorized ? Result.Warning : type,
      title: message,
      timer: 2500,
      showConfirmButton: false
    });
  }
}

/** ... İfade Eder */
export function downloadErrorAlert() {
  Swal.fire({
    icon: "error",
    title: "Sözkonusu Belge Elde Edilemedi!",
    timer: 2500,
    showConfirmButton: false
  });
}

/** Belli Bir Sınıf Değerinin Tamsayı (Integer) Eşdeğerini Elde Eder */
export function getGradeInt(value) {
  let grade = parseInt(value);

  if (isNaN(grade))
  {
    if (value === "Kreş") grade = -1;
    else if (value === "Anaokulu") grade = 0;
    else if (value === "Mezun") grade = 15;
    else if (value === "Yetişkin") grade = 16;
  }

  return grade;
}

/** Belli Bir Sınıf Düzeyine Ait Sınıf Seçeneklerini Elde Eder */
export function getGradeOptions(level) {
  if (level === GradeLevel.Kindergarten) return [{ value: "Kreş", label: "Kreş" }];
  if (level === GradeLevel.Preschool) return [{ value: "Anaokulu", label: "Anaokulu" }];
  if (level === GradeLevel.ElementarySchool) {
    return [
      { value: "1", label: "1" },
      { value: "2", label: "2" },
      { value: "3", label: "3" },
      { value: "4", label: "4" }
    ];
  }
  if (level === GradeLevel.MiddleSchool) {
    return [
      { value: "5", label: "5" },
      { value: "6", label: "6" },
      { value: "7", label: "7" },
      { value: "8", label: "8" }
    ];
  }
  if (level === GradeLevel.HighSchool) {
    return [
      { value: "9", label: "9" },
      { value: "10", label: "10" },
      { value: "11", label: "11" },
      { value: "12", label: "12" }
    ];
  }
  if (level === GradeLevel.Graduate) return [{ value: "Mezun", label: "Mezun" }];
  if (level === GradeLevel.Adult) return [{ value: "Yetişkin", label: "Yetişkin" }];
}

/** Belli Bir Kitap Kategorisine Ait Kitap Türlerini İfade Eder */
export function getBookTypeOptions(category) {
  if (category === BookCategory.ReferenceBooks) return ReferenceBookTypeOptions;
  else if (category === BookCategory.Computer) return ComputerTypeOptions;
  else if (category === BookCategory.ScienceEngineering) return ScienceEngineeringTypeOptions;
  else if (category === BookCategory.ChildrenBooks) return ChildrenBookTypeOptions;
  else if (category === BookCategory.Magazine) return MagazineTypeOptions;
  else if (category === BookCategory.Other) return OtherTypeOptions;
  else if (category === BookCategory.Literature) return LiteratureTypeOptions;
}

/** Belli Bir Dosyayı İndirir */
export function saveAsFile(file, filename) {
  saveAs(file, filename);
}

/** Konu Kazanımı Excele Aktarım Şablonunu İndirir */
export function downloadSubjectOutcomeTemplate() {
  const filename = "Konu Kazanımı Aktarım Şablonu";
  const sheetname = "Konu Kazanımı Aktarım Şablonu";
  const columns = ["Konu Tanımı", "Konu Kodu", "Konu Açıklaması", "Kazanım Tanımı", "Kazanım Açıklaması"];
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet(sheetname);
  worksheet.addRow(columns);
  worksheet.getRow(1).height = 30;
  worksheet.getRow(1).font = { bold: true };
  worksheet.getColumn(1).width = 40;
  worksheet.getColumn(2).width = 20;
  worksheet.getColumn(3).width = 60;
  worksheet.getColumn(4).width = 40;
  worksheet.getColumn(5).width = 60;
  worksheet.eachRow(row => row.alignment = { vertical: "middle", horizontal: "center", wrapText: true });
  saveAsExcel(workbook, filename);
}

/** Ödev Kaynağı Excele Aktarım Şablonunu İndirir */
export function downloadHomeworkSourceTemplate(courses) {
  const filename = "Ödev Kaynağı Aktarım Şablonu";
  const sheetname = "Ödev Kaynağı Aktarım Şablonu";
  const columns = ["Sınıf", "Ders", "Kaynak Adı", "Sayfa Sayısı", "", "Dersler", "", "Sınıflar"];
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet(sheetname);
  worksheet.addRow(columns);

  courses.forEach((course, i) => {
    const row = worksheet.getRow(i + 2);
    row.getCell(6).value = course;
  });

  GradeOptions.map(option => option.value).forEach((value, i) => {
    const row = worksheet.getRow(i + 2);
    row.getCell(8).value = value;
  });

  worksheet.getRow(1).height = 30;
  worksheet.getRow(1).font = { bold: true };
  worksheet.getColumn(1).width = 20;
  worksheet.getColumn(2).width = 40;
  worksheet.getColumn(3).width = 40;
  worksheet.getColumn(4).width = 20;
  worksheet.getColumn(6).width = 40;
  worksheet.getColumn(8).width = 20;

  worksheet.eachRow((row, i) => {
    row.alignment = { vertical: "middle", wrapText: true };
    if (i === 1) row.alignment.horizontal = "center";
  });
  
  saveAsExcel(workbook, filename);
}

/** Belli Bir Ders Konusu ve Konulara Ait Kazanım Listesini Excelden Elde Eder */
export async function getCourseSubjectAndOutcomeData(e) {
  const subjectAndOutcomes = [];
  const workbook = new Excel.Workbook();
  await workbook.xlsx.load(e.target.result);  

  workbook.worksheets[0].eachRow((row, i) => {
    if (i === 1) return;

    const subjectAndOutcome = {
      subject: row.getCell(1).value?.toString(),
      subjectCode: row.getCell(2).value?.toString(),
      subjectExplanation: row.getCell(3).value?.toString(),
      outcome: row.getCell(4).value?.toString(),
      outcomeExplanation: row.getCell(5).value?.toString()
    };
    subjectAndOutcomes.push(subjectAndOutcome);
  });

  return subjectAndOutcomes;
}

/** Belli Bir Ödev Kaynak Listesini Excelden Elde Eder */
export async function getHomeworkResourceData(e) {
  const homeworkSources = [];
  const workbook = new Excel.Workbook();
  await workbook.xlsx.load(e.target.result);  

  workbook.worksheets[0].eachRow((row, i) => {
    if (i === 1) return;

    const homeworkSource = {
      grade: row.getCell(1).value?.toString(),
      course: row.getCell(2).value?.toString(),
      name: row.getCell(3).value?.toString(),
      pageNumber: row.getCell(4).value?.toString()
    };
    homeworkSources.push(homeworkSource);
  });

  return homeworkSources;
}

/** Belli Bir ASC Verisini Xml e Aktarır */
export function exportASCDataToXml(params) {
  const { courses, sections, teachers } = params;
  const xmlDoc = document.implementation.createDocument(null, null);
  const timetable = xmlDoc.createElement("timetable");

  // ...
  const xml = xmlDoc.createProcessingInstruction('xml', 'version="1.0" encoding="utf-8"');
  xmlDoc.insertBefore(xml, xmlDoc.firstChild);

  // ...
  timetable.setAttribute("xmlns:xsi", "http://www.w3.org/2001/XMLSchema-instance");
  timetable.setAttribute("xmlns:xsd", "http://www.w3.org/2001/XMLScheme");
  timetable.setAttribute("importtype", "database");
  timetable.setAttribute("options", "export:idprefix:%CHRID,import:idprefix:%TEMPID,groupstype1,decimalseparatordot,lessonsincludeclasseswithoutstudents,handlestudentsafterlessons");
  timetable.setAttribute("defaultexport", 1);
  timetable.setAttribute("displayname", "School Application");
  timetable.setAttribute("displaycountries", "");

  // ...
  const subjects = xmlDoc.createElement("subjects");
  subjects.setAttribute("options", "canadd,export:silent");
  subjects.setAttribute("columns", "id,name,short,partner_id");

  courses.forEach(course => {
    const subject = xmlDoc.createElement("subject");
    subject.setAttribute("id", course.value);
    subject.setAttribute("name", course.label);
    subject.setAttribute("short", course.label.length > 3 ? course.label.slice(0, 3) : course.label);
    subject.setAttribute("partner_id", course.value);
    subjects.appendChild(subject);
  });

  // ...
  const teacherList = xmlDoc.createElement("teachers");
  teacherList.setAttribute("options", "canadd,export:silent");
  teacherList.setAttribute("columns", "id,name,short,gender,color,email,mobile,partner_id,firstname,lastname");

  teachers.forEach(teacher => {
    const element = xmlDoc.createElement("teacher");
    element.setAttribute("id", teacher.id);
    element.setAttribute("firstname", teacher.name);
    element.setAttribute("lastname", teacher.surname);
    element.setAttribute("name", teacher.name + " " + teacher.surname);
    element.setAttribute("short", teacher.name.slice(0, 1) + teacher.surname.slice(0, 1));
    element.setAttribute("gender", teacher.sexName.slice(0, 1));
    element.setAttribute("color", "#FF0000");
    element.setAttribute("email", teacher.email1);
    element.setAttribute("mobile", teacher.mobilePhone1);
    element.setAttribute("partner_id", teacher.id);
    teacherList.appendChild(element);
  });

  // ...
  const classrooms = xmlDoc.createElement("classrooms");
  classrooms.setAttribute("options", "canadd,export:silent");
  classrooms.setAttribute("columns", "id,name,short,capacity,partner_id");

  sections.forEach(section => {
    const classroom = xmlDoc.createElement("classroom");
    classroom.setAttribute("id", section.value);
    classroom.setAttribute("name", section.label);
    classroom.setAttribute("short", section.label);
    classroom.setAttribute("capacity", "*");
    classroom.setAttribute("partner_id", section.value);
    classrooms.appendChild(classroom);
  });

  // ...
  const classes = xmlDoc.createElement("classes");
  classes.setAttribute("options", "canadd,export:silent");
  classes.setAttribute("columns", "id,name,short,classroomids,teacherid,grade,partner_id");

  sections.forEach(section => {
    const element = xmlDoc.createElement("class");
    element.setAttribute("id", section.value);
    element.setAttribute("name", section.label);
    element.setAttribute("short", section.label);
    element.setAttribute("classroomids", section.value);
    element.setAttribute("partner_id", section.value);
    classes.appendChild(element);
  });

  // ...
  timetable.appendChild(subjects);
  timetable.appendChild(teacherList);
  timetable.appendChild(classrooms);
  timetable.appendChild(classes);
  xmlDoc.appendChild(timetable);

  let xmlString = new XMLSerializer().serializeToString(xmlDoc);
  xmlString = xmlString.replaceAll("<subject", "    <subject").replace("    <subjects", "  <subjects").replace("</subjects>", "  </subjects>");
  xmlString = xmlString.replaceAll("<teacher", "    <teacher").replace("    <teachers", "  <teachers").replace("</teachers>", "  </teachers>");
  xmlString = xmlString.replaceAll("<class", "    <class").replace("    <classes", "  <classes").replace("</classes>", "  </classes>");
  xmlString = xmlString.replaceAll("    <classrooms", "  <classrooms").replace("</classrooms>", "  </classrooms>");
  xmlString = xmlString.replaceAll(">", ">\n").replace("</timetable>\n", "</timetable>");
  saveAsXml(xmlString,  "ASC Veri Dosyası");  
}

/** Belli Bir Xml Dosyayını Xml Formatında İndirir */
function saveAsXml(xmlString, filename) {
  const data = new Blob([xmlString], { type: "application/xml" });
  saveAs(data, filename);
}

/** Belli Bir */
export function getAllDayAndHourData(e) {
  const dayAndHourData = [];
  const xmlDoc = new DOMParser().parseFromString(e.target.result, "text/xml");

  if (xmlDoc.getElementsByTagName("cards").length === 0 || xmlDoc.getElementsByTagName("cards")[0].getElementsByTagName("card").length === 0 ||
      xmlDoc.getElementsByTagName("lessons").length === 0 || xmlDoc.getElementsByTagName("lessons")[0].getElementsByTagName("lesson").length === 0 ||
      xmlDoc.getElementsByTagName("daysdefs").length === 0 || xmlDoc.getElementsByTagName("subjects").length === 0 ||
      xmlDoc.getElementsByTagName("classes").length === 0 || xmlDoc.getElementsByTagName("teachers").length === 0) {
    return;
  }

  for (let item of xmlDoc.getElementsByTagName("cards")[0].getElementsByTagName("card")) {
    const lesson = Array.from(xmlDoc.getElementsByTagName("lessons")[0].getElementsByTagName("lesson")).find(lesson => lesson.getAttribute("id") === item.getAttribute("lessonid"));
    
    if (!lesson || !lesson.getAttribute("subjectid") || !lesson.getAttribute("classids") || !lesson.getAttribute("teacherids") ||
        !item.getAttribute("days") || !item.getAttribute("period")) {
      return;
    }

    const day = getDay(xmlDoc.getElementsByTagName("daysdefs"), item.getAttribute("days"));
    const courseId = getCourseId(xmlDoc.getElementsByTagName("subjects"), lesson.getAttribute("subjectid"));
    const sectionIds = getSectionIds(xmlDoc.getElementsByTagName("classes"), lesson.getAttribute("classids"));
    const teacherIds = getTeacherIds(xmlDoc.getElementsByTagName("teachers"), lesson.getAttribute("teacherids"));

    sectionIds.forEach(sectionId => {
      teacherIds.forEach(teacherId => {
        const dataInThisDayAndHour = {
          day: day,
          hour: item.getAttribute("period"),
          courseId: courseId,
          sectionId: sectionId,
          teacherId: teacherId
        };
        dayAndHourData.push(dataInThisDayAndHour);
      });
    });
  }
  
  return dayAndHourData;
}

/** */
function getDay(daysdefs, days) {
  let day;
  const names = Array.from(daysdefs[0].getElementsByTagName("daysdef")).find(daysdef => daysdef.getAttribute("days") === days);

  if (names && names.getAttribute("name")) {
    if (names.getAttribute("name").toLowerCase() === Days[0].toLowerCase() || names.getAttribute("name").toLowerCase() === DaysInEnglish[0].toLowerCase()) day = 1;
    else if (names.getAttribute("name").toLowerCase() === Days[1].toLowerCase() || names.getAttribute("name").toLowerCase() === DaysInEnglish[1].toLowerCase()) day = 2;
    else if (names.getAttribute("name").toLowerCase() === Days[2].toLowerCase() || names.getAttribute("name").toLowerCase() === DaysInEnglish[2].toLowerCase()) day = 3;
    else if (names.getAttribute("name").toLowerCase() === Days[3].toLowerCase() || names.getAttribute("name").toLowerCase() === DaysInEnglish[3].toLowerCase()) day = 4;
    else if (names.getAttribute("name").toLowerCase() === Days[4].toLowerCase() || names.getAttribute("name").toLowerCase() === DaysInEnglish[4].toLowerCase()) day = 5;
    else if (names.getAttribute("name").toLowerCase() === Days[5].toLowerCase() || names.getAttribute("name").toLowerCase() === DaysInEnglish[5].toLowerCase()) day = 6;
    else if (names.getAttribute("name").toLowerCase() === Days[6].toLowerCase() || names.getAttribute("name").toLowerCase() === DaysInEnglish[6].toLowerCase()) day = 7;
  }
  
  return day;
}

/** */
function getCourseId(subjects, subjectId) {
  const course = Array.from(subjects[0].getElementsByTagName("subject")).find(subject => subject.getAttribute("id") === subjectId);
  return course && course.getAttribute("partner_id") ? course.getAttribute("partner_id") : "";
}

/** */
function getSectionIds(classes, classIds) {
  const sectionIds = [];  
  classIds.split(",").forEach(classId => {
    const section = Array.from(classes[0].getElementsByTagName("class")).find(element => element.getAttribute("id") === classId);
    const sectionId = section && section.getAttribute("partner_id") ? section.getAttribute("partner_id") : "";
    sectionIds.push(sectionId);
  });

  return sectionIds;
}

/** */
function getTeacherIds(teachers, teacherIds) {
  const teacherIdList = [];
  teacherIds.split(",").forEach(id => {
    const teacher = Array.from(teachers[0].getElementsByTagName("teacher")).find(teacher => teacher.getAttribute("id") === id);
    const teacherId = teacher && teacher.getAttribute("partner_id") ? teacher.getAttribute("partner_id") : "";
    teacherIdList.push(teacherId);
  });

  return teacherIdList;
}

/** Belli Bir Listeyi Excele Aktarır */
export function exportToExcel(params) {
  let { columns, rows, widths, filename, sheetname } = params;
  sheetname = sheetname ? sheetname : filename;
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet(sheetname);
  worksheet.addRow([filename]);
  worksheet.addRow(columns);
  rows.forEach(row => worksheet.addRow(row));
  worksheet.columns.forEach((column, i) => column.width = widths[i]);
  worksheet.mergeCells(1, 1, 1, columns.length);
  worksheet.eachRow(row => {
    row.alignment = { vertical: "middle", wrapText: true };
    row.height = 25;
  });
  worksheet.getRow(1).alignment = { vertical: "middle", horizontal: "center" };
  worksheet.getRow(2).alignment = { vertical: "middle", horizontal: "center" };
  worksheet.getRow(1).font = { bold: true };  
  worksheet.getRow(2).font = { bold: true };
  saveAsExcel(workbook, filename);
}

/** Belli Bir Sınıf veya Öğretmen Ders Programını Excele Aktarır */
export function exportTimetableToExcel(params) {
  const columns = getTimetableColumns();
  const { tableType, courseHours, timetable, filename, sheetname } = params;
  let { workbook, worksheet } = getTimetableWorkbook(columns, filename, sheetname);
  setTimetableWorksheet(courseHours, timetable, tableType, worksheet);
  saveAsExcel(workbook, filename);
}

/** Belli Bir Ders Programını Excele Aktarır */
export function exportAllTimetableToExcel(params) {
  const columns = getTimetableColumns();
  const { type, headers, courseHours, timetable, filename, sheetname } = params;
  let { workbook, worksheet } = getTimetableWorkbook(columns, filename, sheetname);

  headers.forEach((header, i) => {
    worksheet.addRow([header.label]);
    worksheet.getRow(i * (courseHours.length + 1) + 3).height = 30;
    worksheet.getRow(i * (courseHours.length + 1) + 3).font = { bold: true };
    worksheet.mergeCells(i * (courseHours.length + 1) + 3, 1, i * (courseHours.length + 1) + 3, columns.length);
    const table = type === TimetableType.Section ? timetable.filter(table => table.sectionId === header.value) :
                  type === TimetableType.Teacher ? timetable.filter(table => table.teacherId === header.value) : [];
    setTimetableWorksheet(courseHours, table, type, worksheet);    
  });
  
  saveAsExcel(workbook, filename);
}

/** Sınıf veya Öğretmen Ders Programı Excele Aktarım Şablonunu İndirir */
export function downloadTimetableTemplate(params) {
  const { tableType, courseHours, courses, options } = params;
  const header = tableType === TimetableType.Section ? "Öğretmenler" : tableType === TimetableType.Teacher ? "Sınıflar" : "";
  const type = tableType === TimetableType.Section ? "Sınıf" : tableType === TimetableType.Teacher ? "Öğretmen" : "";
  const filename = type + " Ders Programı Aktarım Şablonu";
  const sheetname = type + " Ders Programı";
  const columns = getTimetableColumns();
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet(sheetname);
  worksheet.addRow(columns);
  worksheet.getRow(1).height = 30;
  worksheet.getRow(1).font = { bold: true };
  worksheet.columns.forEach(column => column.width = 25);
  worksheet.getColumn(1).width = 15;
  worksheet.getColumn(1).font = { bold: true };
  worksheet.getColumn(columns.length).width = 15;
  worksheet.getColumn(columns.length).font = { bold: true };

  courseHours.forEach((hour, i) => {
    let row = [hour.courseHour + ". Ders\n" + hour.weekdayStartHour + "\n" + hour.weekdayEndHour];
    
    Days.forEach((day, i) => {
      let firstName = tableType === TimetableType.Section ? "Ders Adı" : tableType === TimetableType.Teacher ? "Sınıf Adı" : "";
      row.push(firstName);
    });

    row.push(hour.courseHour + ". Ders\n" + hour.weekdayStartHour + "\n" + hour.weekdayEndHour);
    worksheet.addRow(row);
    row = [""];

    Days.forEach((day, i) => {  
      let secondName = tableType === TimetableType.Section ? "Öğretmen Adı" : tableType === TimetableType.Teacher ? "Ders Adı" : "";
      row.push(secondName);
    });

    worksheet.addRow(row); 
    worksheet.eachRow(row => row.height = 30);
    worksheet.mergeCells(2 * i + 2, 1, 2 * i + 3, 1);
    worksheet.mergeCells(2 * i + 2, columns.length, 2 * i + 3, columns.length);   
  });
  
  worksheet.getRow(2 * courseHours.length + 3).height = 25;
  worksheet.getRow(2 * courseHours.length + 3).font = { bold: true };
  worksheet.getRow(2 * courseHours.length + 3).getCell(2).value = "Dersler";
  worksheet.getRow(2 * courseHours.length + 3).getCell(4).value = header;
  worksheet.mergeCells(2 * courseHours.length + 3, 2, 2 * courseHours.length + 3, 3);
  worksheet.mergeCells(2 * courseHours.length + 3, 4, 2 * courseHours.length + 3, 5);

  courses.forEach((course, i) => {
    worksheet.getRow(2 * courseHours.length + 4 + i).height = 25;
    worksheet.getRow(2 * courseHours.length + 4 + i).getCell(2).value = course.label;
    worksheet.mergeCells(2 * courseHours.length + 4 + i, 2, 2 * courseHours.length + 4 + i, 3);
  });

  options.forEach((option, i) => {
    worksheet.getRow(2 * courseHours.length + 4 + i).height = 25;
    worksheet.getRow(2 * courseHours.length + 4 + i).getCell(4).value = option.label;
    worksheet.mergeCells(2 * courseHours.length + 4 + i, 4, 2 * courseHours.length + 4 + i, 5);
  });

  worksheet.eachRow(row => row.alignment = { vertical: "middle", horizontal: "center", wrapText: true });
  saveAsExcel(workbook, filename);
}

// ... Elde Eder
function getTimetableColumns() {
  const columns = ["Haftaiçi"];
  Days.forEach(day => columns.push(day));
  columns.push("Haftasonu");
  return columns;
}

/** ... Elde Eder */
function getTimetableWorkbook(columns, filename, sheetname) {
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet(sheetname);
  worksheet.addRow([filename]);
  worksheet.addRow(columns);
  worksheet.getRow(1).height = 30;
  worksheet.getRow(2).height = 30;
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(2).font = { bold: true };  
  worksheet.mergeCells(1, 1, 1, columns.length);
  worksheet.columns.forEach(column => column.width = 25);
  worksheet.getColumn(columns.length).font = { bold: true };
  worksheet.getColumn(columns.length).width = 15;
  worksheet.getColumn(1).font = { bold: true };
  worksheet.getColumn(1).width = 15;
  return { workbook, worksheet };
}

/** ... */
function setTimetableWorksheet(courseHours, table, type, worksheet) {
  courseHours.forEach(hour => {
    const row = [hour.courseHour + ". Ders\n" + hour.weekdayStartHour + "\n" + hour.weekdayEndHour];

    Days.forEach((day, i) => {
      const tableInThisDayAndHour = table.find(table => table.day === i + 1 && table.hour === hour.courseHour);
      let firstName = type === TimetableType.Section ? tableInThisDayAndHour?.courseName : 
                      type === TimetableType.Teacher ? tableInThisDayAndHour?.sectionName : "";
      let secondName = type === TimetableType.Section ? tableInThisDayAndHour?.teacherName : 
                        type === TimetableType.Teacher ? tableInThisDayAndHour?.courseName : "";
      firstName = firstName ? firstName : "";
      secondName = secondName ? secondName : "";

      row.push({ richText: [{ text: firstName}, { text: "\n" + secondName, font: { bold: true } }]});
    });

    row.push(hour.courseHour + ". Ders\n" + hour.weekendStartHour + "\n" + hour.weekendEndHour);
    worksheet.addRow(row);
    worksheet.eachRow(row => row.alignment = { vertical: "middle", horizontal: "center", wrapText: true });
  });
}

/** Belli Bir Sınıf ve Şube Raporunu Excele Aktarır */
export function exportGradeAndSectionReportToExcel(params) {
  let { columns, rows, widths, filename, sheetname } = params;
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet(sheetname);
  worksheet.addRow([filename]);
  worksheet.addRow(columns);
  rows.forEach(row => worksheet.addRow(row));
  worksheet.columns.forEach((column, i) => column.width = widths[i]);
  worksheet.mergeCells(1, 1, 1, columns.length);
  worksheet.eachRow(row => {
    if ((row.cellCount === 8 && !row.getCell(2).value) || (row.cellCount === 9 && !row.getCell(3).value)) row.font = { bold: true };
    row.alignment = { vertical: "middle", wrapText: true };
    row.height = 25;
  });
  worksheet.getRow(1).alignment = { vertical: "middle", horizontal: "center" };
  worksheet.getRow(2).alignment = { vertical: "middle", horizontal: "center" };
  worksheet.getRow(1).font = { bold: true };  
  worksheet.getRow(2).font = { bold: true };
  saveAsExcel(workbook, filename);
}

/** Belli Bir Sınıf Yoklaması Listesini Excele Aktarır */
export function exportSectionAttendancesToExcel(params) {
  let { columns, rows, widths, filename, sheetname } = params;
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet(sheetname);
  worksheet.addRow([filename]);
  worksheet.addRow(columns);
  rows.forEach(row => worksheet.addRow(row));
  worksheet.columns.forEach((column, i) => column.width = widths[i]);
  worksheet.mergeCells(1, 1, 1, columns.length);
  worksheet.eachRow(row => {
    row.eachCell(cell => { if (cell.text.includes("Alınmadı")) cell.font = { bold: true }; });
    row.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    row.height = 60;
  });
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(2).font = { bold: true };
  worksheet.getRow(1).height = 25;
  worksheet.getRow(2).height = 25;
  saveAsExcel(workbook, filename);
}

/** Belli Bir Excel Dosyayını Excel Formatında İndirir */
async function saveAsExcel(workbook, filename) {  
  const buffer = await workbook.xlsx.writeBuffer();
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const data = new Blob([buffer], { type: fileType });
  saveAs(data, filename.replace(".", ""));
}

/** Belli Bir ... */
export async function getDayAndHourData(params) {
  const dayAndHourData = [];
  const { tableType, courseHours, courses, sections, teachers, e } = params;  
  const workbook = new Excel.Workbook();
  await workbook.xlsx.load(e.target.result);

  courseHours.forEach((hour, i) => {
    Days.forEach((day, j) => {
      let firstId;
      let secondId;

      if (tableType === TimetableType.Section) {
        let courseName = workbook.worksheets[0].getRow(2 * i + 2).getCell(j + 2).value;
        let teacherName = workbook.worksheets[0].getRow(2 * i + 3).getCell(j + 2).value;
        courseName = courseName ? courseName.replaceAll(" ", "") : "";
        teacherName = teacherName ? teacherName.replaceAll(" ", "").split("(")[0] : "";
        const course = courses.find(course => course.label.replaceAll(" ", "") === courseName);
        const teacher = teachers.find(teacher => teacher.label.replaceAll(" ", "").split("(")[0] === teacherName);
        firstId = course ? course.value : null;
        secondId = teacher ? teacher.value : null;
        if (!firstId && !secondId) return;
      
      } else if (tableType === TimetableType.Teacher) {  
        let courseName = workbook.worksheets[0].getRow(2 * i + 3).getCell(j + 2).value;
        let sectionName = workbook.worksheets[0].getRow(2 * i + 2).getCell(j + 2).value;
        courseName = courseName ? courseName.replaceAll(" ", "") : "";
        sectionName = sectionName ? sectionName.replaceAll(" ", "") : "";
        const course = courses.find(course => course.label.replaceAll(" ", "") === courseName);
        const section = sections.find(section => section.label.replaceAll(" ", "") === sectionName);
        firstId = section ? section.value : null;
        secondId = course ? course.value : null;
        if (!firstId && !secondId) return;
      }      
      const dataInThisDayAndHour = {
        day : j + 1,
        hour: hour.courseHour,
        firstId : firstId,
        secondId: secondId
      };
      dayAndHourData.push(dataInThisDayAndHour);      
    });
  });

  return dayAndHourData;
}

/** Belli Bir Listeyi PDF e Aktarır */
export async function exportToPDF(views, filename) {  
  const blob = await pdf(
    <PDFDocument 
      views={views}
      filename={filename}
    />
  ).toBlob();

  saveAs(blob, filename.replace(".", ""));
}

/** Belli Bir Sınıf veya Öğretmen Ders Programını PDF e Aktarır */
export async function exportTimetableToPDF(params) {
  const { courseHours, timetable, tableType, filename } = params;
  const views = getTimetableViews(courseHours, timetable, tableType);

  const blob = await pdf(
    <TimetablePDFDocument
      views={views}
      filename={filename}
    />
  ).toBlob();

  saveAs(blob, filename.replace(".", ""));
}

/** Belli Bir Ders Programını Excele Aktarır */
export async function exportAllTimetableToPDF(params) {
  const { dispatch, type, headers, courseHours, timetable, filename } = params;
  dispatch(actions.startAction());

  const blob = await pdf(
    <AllTimetablePDFDocument
      type={type}
      headers={headers}
      courseHours={courseHours}
      timetable={timetable}
      filename={filename}
    />
  ).toBlob();

  saveAs(blob, filename.replace(".", ""));
  dispatch(actions.completeAction());
}

/** Belli Bir Sınıf ve Şube Raporunu PDF e Aktarır */
export async function exportGradeAndSectionReportToPDF(views, filename) {
  const blob = await pdf(
    <GradeAndSectionReportPDFDocument 
      views={views}
      filename={filename}
    />
  ).toBlob();

  saveAs(blob, filename.replace(".", ""));
}

/** Belli Bir Sınıf Yoklaması Listesini PDF e Aktarır */
export async function exportSectionAttendancesToPDF(views, filename) {
  const blob = await pdf(
    <SectionAttendancesPDFDocument 
      views={views}
      filename={filename}
    />
  ).toBlob();

  saveAs(blob, filename.replace(".", ""));
}

/** ... Elde Eder */
function getTimetableViews(courseHours, table, type) {
  const views = [{ rows: courseHours.map(hour =><Text style={{ fontWeight: "bold" }}>{hour.courseHour + ". Ders\n" + hour.weekdayStartHour + "\n" + hour.weekdayEndHour}</Text>) }];

  Days.forEach((day, i) => {
    const rows = [];
    courseHours.forEach(hour => {
      const tableInThisDayAndHour = table.find(table => table.day === i + 1 && table.hour === hour.courseHour);

      if (tableInThisDayAndHour && type === TimetableType.Section) {
        rows.push(<Text>{tableInThisDayAndHour.courseName + "\n"}<Text style={{ fontWeight: "bold" }}>{tableInThisDayAndHour.teacherName}</Text></Text>);

      } else if (tableInThisDayAndHour && type === TimetableType.Teacher) {
        let sectionName = tableInThisDayAndHour.sectionName;

        if (sectionName.length > 17) {
          const names = tableInThisDayAndHour.sectionName.split("-");
          names[1] = names[1].replace(" ", "");
          sectionName = names[0] + "-\n" + names[1];
        }
        rows.push(<Text>{sectionName + "\n"}<Text style={{ fontWeight: "bold" }}>{tableInThisDayAndHour.courseName}</Text></Text>);

      } else {
        rows.push("");
      }     
    });
    views.push({ rows });
  });

  views.push({ rows: courseHours.map(hour =><Text style={{ fontWeight: "bold" }}>{hour.courseHour + ". Ders\n" + hour.weekendStartHour + "\n" + hour.weekendEndHour}</Text>) });
  return views;
}

/** */
Font.register({
  family: "Roboto",
  fonts: [
    { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf" },
    { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf" }
  ]  
});

/** Aktarılacak PDF Şablonun Style larını Hazırlar */
const styles = StyleSheet.create({
  page: {
    padding: 10,
    fontFamily: "Roboto",
    flexDirection: "column",
    backgroundColor: '#E4E4E4'
  },
  title: {
    marginTop: 10,
    fontSize: 12,
    width: "100vw",
    fontWeight: "bold",
    textAlign: "center"
  },
  table: {
    marginTop: 10,
    flexDirection: "row"
  },
  section: {
    flexGrow: 1,
    flexBasis: "calc(100% - 1rem)"
  },
  header: {
    padding: 5,
    fontSize: 10,
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
    backgroundColor: "#294257",
    borderBottom: "1 solid white"
  },
  row: {
    padding: 5,
    fontSize: 10,
    minHeight: 25,
    border: "1 solid white",
    backgroundColor: "#F3F3F3"
  },
  tableRow: {
    padding: 5,
    fontSize: 10,
    minHeight: 60,
    textAlign: "center",
    border: "1 solid white",
    backgroundColor: "#F3F3F3"
  }
});

/** ... PDF .. */
function PDFDocument({ views, filename }) {
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.title}>
          <Text>{filename}</Text>
        </View>
        <View style={styles.table} fixed>
        {
          views.map((view, i) => (
            <View key={i} style={styles.section}>
              <Text style={styles.header}>{view.header}</Text>
            </View>
          ))
        }
       </View>
       <View style={{ flexDirection: "row" }}>
        {
          views.map((view, i) => (
            <View key={i} style={styles.section}>              
            {
              view.rows.map((row, i) => (
                <Text key={i} style={styles.row} break={i !== 0 && i % 20 === 0}>{row}</Text>
              ))
            }
            </View>
          ))
        }
       </View>
      </Page>
    </Document>
  );
}

/** Timetable PDF ... */
function TimetablePDFDocument({ views, filename }) {
  const columns = getTimetableColumns();
  return (    
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.title}>
          <Text>{filename}</Text>
        </View>
        <View style={styles.table} fixed>
        {
          columns.map((column, i) => (
            <View key={i} style={styles.section}>
              <Text style={styles.header}>{column}</Text>              
            </View>
          ))
        }
        </View>
        <View style={{ flexDirection: "row" }}>
        {
          views.map((view, i) => (
            <View key={i} style={styles.section}>              
            {
              view.rows.map((row, i) => (
                <Text key={i} style={styles.tableRow} break={i !== 0 && i % 8 === 0}>{row}</Text>
              ))
            }              
            </View>
          ))
        }
        </View>
      </Page>
    </Document>
  );
}

/** ... Timetable PDF ... */
function AllTimetablePDFDocument({ type, headers, courseHours, timetable, filename }) {
  const columns = getTimetableColumns();
  return (    
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.title}>
          <Text>{filename}</Text>
        </View>
        <View style={{ flexDirection: "row" }} fixed>
        {
          columns.map((column, i) => (
            <View key={i} style={[styles.section, { marginTop: 10 }]}>
              <Text style={styles.header}>{column}</Text>
            </View>
          ))
        }
        </View>
        {
          headers.map((header, i) => {
            const table = type === TimetableType.Section ? timetable.filter(table => table.sectionId === header.value) :
                          type === TimetableType.Teacher ? timetable.filter(table => table.teacherId === header.value) : [];
            const views = getTimetableViews(courseHours, table, type);

            return (
              <Fragment key={i}>
                <View style={styles.title} break={i > 0}>
                  <Text style={[styles.header, { marginTop: -10, marginRight: 20 }]}>{header.label}</Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                {
                  views.map((view, i) => (
                    <View key={i} style={styles.section}>
                      {
                        view.rows.map((row, i) => (
                          <Text key={i} style={styles.tableRow} break={(i !== 0 && i % 8 === 0)}>{row}</Text>
                        ))
                      }              
                    </View>
                  ))
                }
                </View>
              </Fragment>
            );
          })
        }        
      </Page>
    </Document>
  );
}

/** ... Grade And Section Report PDF .. */
function GradeAndSectionReportPDFDocument({ views, filename }) {
  const indices = [];
  views.filter(view => view.header === "Şube").forEach(view => 
    view.rows.forEach((row, i) => { if (row === "") indices.push(i); })
  );

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.title}>
          <Text>{filename}</Text>
        </View>
        <View style={styles.table} fixed>
        {
          views.map((view, i) => (
            <View key={i} style={styles.section}>
              <Text style={styles.header}>{view.header}</Text>
            </View>
          ))
        }
       </View>
       <View style={{ flexDirection: "row" }}>
        {
          views.map((view, i) => (
            <View key={i} style={styles.section}>
            {
              view.rows.map((row, i) => {
                const weight = indices.includes(i) ? "bold" : "normal";
                return (
                  <Text key={i} style={[styles.row, { fontWeight: weight }]} break={i !== 0 && i % 20 === 0}>{row}</Text>
                );
              })
            }
            </View>
          ))
        }
       </View>
      </Page>
    </Document>
  );
}

/** ... Section Attendances PDF .. */
function SectionAttendancesPDFDocument({ views, filename }) {
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.title}>
          <Text>{filename}</Text>
        </View>
        <View style={styles.table} fixed>
        {
          views.map((view, i) => (
            <View key={i} style={styles.section}>
              <Text style={styles.header}>{view.header}</Text>
            </View>
          ))
        }
       </View>
       <View style={{ flexDirection: "row" }}>
        {
          views.map((view, i) => (
            <View key={i} style={styles.section}>              
            {
              view.rows.map((row, i) => {
                const weight = row.includes("Alınmadı") ? "bold" : "normal";
                return (
                  <Text key={i} style={[styles.tableRow, { fontWeight: weight, minHeight: 70 }]} break={i !== 0 && i % 7 === 0}>{row}</Text>
                );
              })
            }
            </View>
          ))
        }
       </View>
      </Page>
    </Document>
  );
}

/** Belli Bir Listeyi Yazdırma Penceresini Açar */
export function print(params) {
  const { data, properties, header, style } = params;
  printJS({
    type: "json",
    documentTitle: "",
    printable: data,
    properties: properties,
    header: `<h4 class="center">${header}</h4>`,
    style: ".center { text-align: center; font-size: 20px; font-family: Roboto, sans-serif }",    
    gridHeaderStyle: "font-weight: bold; font-size: 11px; border: 1px solid lightgray; font-family: Roboto, sans-serif; padding: 10px",
    gridStyle: `border: 1px solid lightgray; margin-bottom: -1px; font-size: 11px; font-family: Roboto, sans-serif; padding: 10px; page-break-inside: avoid; ${style}` 
  });
}

/** Belli Bir Sınıf veya Öğretmen Ders Programını Yazdırma Penceresini Açar */
export function printTimetable(params) {
  const { tableType, header, courseHours, timetable } = params;
  const data = [];
  const properties = getTimetableColumns();

  courseHours.forEach(hour => {
    const columns = { "Haftaiçi": "<b>" + hour.courseHour + ". Ders<br />" + hour.weekdayStartHour + "<br />" + hour.weekdayEndHour + "</b>" };

    Days.forEach((day, i) => {
      const tableInThisDayAndHour = timetable.find(table => table.day === i + 1 && table.hour === hour.courseHour);
      let firstName = tableType === TimetableType.Section ? tableInThisDayAndHour?.courseName : 
                      tableType === TimetableType.Teacher ? tableInThisDayAndHour?.sectionName : "";
      let secondName = tableType === TimetableType.Section ? tableInThisDayAndHour?.teacherName : 
                       tableType === TimetableType.Teacher ? tableInThisDayAndHour?.courseName : "";
      firstName = firstName ? firstName : "";
      secondName = secondName ? secondName : "";
      columns[day] = firstName + "<br /><b>" + secondName + "</b>";
    });

    columns["Haftasonu"] = "<b>" + hour.courseHour + ". Ders<br />" + hour.weekendStartHour + "<br />" + hour.weekendEndHour + "</b>";
    data.push(columns);
  });

  print({ data, properties, header, style : "text-align: center; height: 60px" });
}

/** Belli Bir Ders Programını Yazdırma Penceresini Açar */
export function printAllTimetable(params) {
  const table = getAllTimetableHtml(params);
  table.setAttribute("id", "timetable");
  document.body.appendChild(table);

  printJS({
    type: "html",    
    documentTitle: "",
    printable: "timetable",
    style: `table, th, td { border: 1px solid lightgray; border-collapse: collapse; margin-bottom: -1px; font-size: 11px; font-family: Roboto, sans-serif; padding: 10px; text-align: center }
            th[colspan] { page-break-before: always } tr { page-break-inside: avoid }`,
    maxWidth: 1050
  });

  document.body.removeChild(table);
}

/** Belli Bir Listeyi Panoya Kopyalar */
export function copy(params) {
  const { header, columns, rows } = params;
  const table = document.createElement("table");
  const thead = getTableHeader(header, columns);
  const tbody = document.createElement("tbody");  

  rows.forEach(row => {
    const tr = document.createElement("tr");
    row.forEach(field => {
      const td = document.createElement("td");
      const text = document.createTextNode(field);
      td.appendChild(text);
      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  });

  table.appendChild(thead);
  table.appendChild(tbody);
  copyToClipboard(table, "Bilgiler Panoya Kopyalanmıştır");  
}

/** Belli Bir Sınıf veya Öğretmen Ders Programını Panoya Kopyalar */
export function copyTimetable(params) {
  const { tableType, header, courseHours, timetable } = params;
  const columns = getTimetableColumns();
  const table = document.createElement("table");
  const thead = getTableHeader(header, columns);
  let tbody = document.createElement("tbody");
  tbody = getTimetableBody(tbody, tableType, courseHours, timetable);
  table.appendChild(thead);
  table.appendChild(tbody);
  copyToClipboard(table, "Ders Programı Panoya Kopyalanmıştır");
}

/** Belli Bir Ders Programını Panoya Kopyalar */
export function copyAllTimetable(params) {
  const table = getAllTimetableHtml(params);
  copyToClipboard(table, "Ders Programı Panoya Kopyalanmıştır");
}

/** Belli Bir Ders Programının Tablo (Table) Html ini Elde Eder */
function getAllTimetableHtml(params) {
  const { type, term, semester, headers, courseHours, timetable } = params;
  const columns = getTimetableColumns();
  const table = document.createElement("table");
  let tbody = document.createElement("tbody");

  headers.forEach(header => {
    const tableHeader = term + " - " + (term + 1) + " Eğitim Öğretim Yılı " + semester + ". Dönem " + header.label + " Ders Programı";
    let tr = document.createElement("tr");
    const th = document.createElement("th");
    const text = document.createTextNode(tableHeader);
    th.setAttribute("colspan", columns.length);
    th.appendChild(text);
    tr.appendChild(th);
    tbody.appendChild(tr);
    tr = document.createElement("tr");

    columns.forEach(column => {      
      const th = document.createElement("th");
      const text = document.createTextNode(column);
      th.appendChild(text);
      tr.appendChild(th);
    });

    tbody.appendChild(tr);    
    const table = type === TimetableType.Section ? timetable.filter(table => table.sectionId === header.value) :
                  type === TimetableType.Teacher ? timetable.filter(table => table.teacherId === header.value) : [];
    tbody = getTimetableBody(tbody, type, courseHours, table);
  });

  table.appendChild(tbody);
  return table;
}

/** ... Elde Eder */
function getTableHeader(header, columns) {
  const thead = document.createElement("thead");
  let tr = document.createElement("tr");
  const th = document.createElement("th");
  const text = document.createTextNode(header);
  th.setAttribute("colspan", columns.length);
  th.appendChild(text);
  tr.appendChild(th);
  thead.appendChild(tr);
  tr = document.createElement("tr");

  columns.forEach(column => {
    const th = document.createElement("th");
    const text = document.createTextNode(column);
    th.appendChild(text);
    tr.appendChild(th);
  });

  thead.appendChild(tr);
  return thead;
}

/** ... Elde Eder */
function getTimetableBody(tbody, tableType, courseHours, timetable) {
  courseHours.forEach(hour => {
    const tr = document.createElement("tr");
    let th = document.createElement("th");
    th.innerHTML = "<b>" + hour.courseHour + ". Ders<br />" + hour.weekdayStartHour + "<br />" + hour.weekdayEndHour + "</b>";
    tr.appendChild(th);

    Days.forEach((day, i) => {
      const tableInThisDayAndHour = timetable.find(table => table.day === i + 1 && table.hour === hour.courseHour);
      let firstName = tableType === TimetableType.Section ? tableInThisDayAndHour?.courseName : 
                      tableType === TimetableType.Teacher ? tableInThisDayAndHour?.sectionName : "";
      let secondName = tableType === TimetableType.Section ? tableInThisDayAndHour?.teacherName : 
                       tableType === TimetableType.Teacher ? tableInThisDayAndHour?.courseName : "";
      firstName = firstName ? firstName : "";
      secondName = secondName ? secondName : "";      
      const td = document.createElement("td");
      td.innerHTML = firstName + "<br /><b>" + secondName + "</b>";
      tr.appendChild(td);
    });

    th = document.createElement("th");
    th.innerHTML = "<b>" + hour.courseHour + ". Ders<br />" + hour.weekendStartHour + "<br />" + hour.weekendEndHour + "</b>";
    tr.appendChild(th);
    tbody.appendChild(tr);
  });

  return tbody;
}

/** Belli Bir Sınıf ve Şube Raporunu Panoya Kopyalar */
export function copyGradeAndSectionReport(params) {
  const { header, columns, rows } = params;
  const table = document.createElement("table");
  const thead = getTableHeader(header, columns);
  const tbody = document.createElement("tbody");

  rows.forEach(row => {
    const tr = document.createElement("tr");
    row.forEach(field => {
      const td = document.createElement("td");      
      const text = document.createTextNode(field);
      const isHeaderRow = row.some((field, i) => columns.indexOf("Şube") === i && field === "");

      if (isHeaderRow) {
        const b = document.createElement("b");
        b.appendChild(text);
        td.appendChild(b);

      } else {
        td.appendChild(text);
      }

      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  });

  table.appendChild(thead);
  table.appendChild(tbody);
  copyToClipboard(table, "Sınıf ve Şube Raporu Panoya Kopyalanmıştır");  
}

/** Belli Bir Sınıf Yoklama Listesini Panoya Kopyalar */
export function copySectionAttendances(params) {
  const { header, columns, rows } = params;
  const table = document.createElement("table");
  const thead = getTableHeader(header, columns);
  const tbody = document.createElement("tbody");  

  rows.forEach(row => {
    const tr = document.createElement("tr");
    row.forEach(field => {
      const td = document.createElement("td");

      if (field.split("\n")[1]) {
        if (field.split("\n")[1].includes("Alınmadı")) td.innerHTML = "<b>" + field.split("\n")[0] + "<br />" + field.split("\n")[1] + "</b>";
        else td.innerHTML = field.split("\n")[0] + "<br />" + field.split("\n")[1];
      }
      else td.innerHTML = field;

      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  });

  table.appendChild(thead);
  table.appendChild(tbody);
  copyToClipboard(table, "Sınıf Yoklamaları Panoya Kopyalanmıştır");  
}

/** Belli Bir Tabloyu Panoya Kopyalar */
function copyToClipboard(table, message) {  
  document.body.appendChild(table);

  const range = document.createRange();
  range.selectNode(table);
  window.getSelection().removeAllRanges();
  window.getSelection().addRange(range);

  document.execCommand("copy");
  document.body.removeChild(table);
  window.getSelection().removeAllRanges();
  resultAlert(Result.Success, message);
}

/** */
export function getNewDayAndHourDataValues(values, newValue) {
  let newValues = values.filter(value => value.day !== newValue.day || value.hour !== newValue.hour);
  if (newValue.firstId || newValue.secondId) return [...newValues, newValue];
  return newValues;
}

/** */
export function getNewStudentValues(values, relationship, member) {
  const newValues = { ...values };
  if (relationship === Relationship.Father) newValues.father = member;
  else if (relationship === Relationship.Mother) newValues.mother = member;
  else if (relationship === Relationship.Other) newValues.other = member;
  return newValues;
}

/** İleri (Forward) Butonunu İfade Eder */
export function ForwardButton({ method }) {
  return (
    <button
      type="button"
      className="btn btn-primary"
      onClick={method}
    >
      İleri
      <span className="svg-icon svg-icon-md ml-1">
        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-right.svg")} />
      </span>
    </button>
  );
}

/** Geri (Backward) Butonunu İfade Eder */
export function BackwardButton({ method }) {
  return (
    <button
      type="button"
      className="btn btn-danger"
      onClick={method}
    >
      <span className="svg-icon svg-icon-md">
        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-left.svg")} />
      </span>
      Geri      
    </button>
  );
}

/** Bilgi (Info) Butonunu İfade Eder */
export function InfoButton({ path, title, method }) {
  return (
    <button
      type="button"
      className="btn btn-info"
      onClick={method}
    >
      <span className="svg-icon svg-icon-md">
        <SVG src={toAbsoluteUrl("/media/svg/icons/" + path + ".svg")} />
      </span>
      {title}
    </button>
  );
}

/** Aktarım Butonunu İfade Eder */
export function ExportButton({ exportToExcel, exportToPDF, print, copy }) {
  const title = <>
                  <span className="svg-icon svg-icon-md svg-icon-secondary mr-2">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Export.svg")} />
                  </span>
                  Aktar
                </>;

  return (
    <DropdownButton className="ml-2" variant="secondary" title={title} id="aktar">
      <Dropdown.Item eventKey="1" onClick={exportToExcel}>
        <span className="svg-icon menu-icon svg-icon-secondary mr-2">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Export.svg")} />
        </span>
        Excele Aktar
      </Dropdown.Item>
      <Dropdown.Item eventKey="2" onClick={exportToPDF}>
        <span className="svg-icon menu-icon svg-icon-secondary mr-2">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Export.svg")} />
        </span>
        PDF e Aktar
      </Dropdown.Item>
      <Dropdown.Item eventKey="3" onClick={print}>
        <span className="svg-icon menu-icon svg-icon-secondary mr-2">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Devices/Printer.svg")} />
        </span>
        Yazdır
      </Dropdown.Item>
      <Dropdown.Item eventKey="4" onClick={copy}>
        <span className="svg-icon menu-icon svg-icon-secondary mr-2">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Clipboard.svg")} />
        </span>Kopyala
      </Dropdown.Item>
    </DropdownButton>
  ); 
}

/** Başarı (Success) Butonunu İfade Eder */
export function SuccessButton({ path, title, method }) {
  return (
    <button
      type="button"
      className="btn btn-success ml-2"
      onClick={method}
    >
      <span className="svg-icon svg-icon-md">
        <SVG src={toAbsoluteUrl("/media/svg/icons/" + path + ".svg")} />
      </span>
      {title}
    </button>
  );
}

/** Form Butonunu (Ekleme veya Düzenleme) İfade Eder */
export function FormButton({ path, title, method }) {
  return (
    <button
      type="button"
      className="btn btn-primary ml-2"
      onClick={method}
    >
      <span className="svg-icon svg-icon-md">
        <SVG src={toAbsoluteUrl("/media/svg/icons/" + path + ".svg")} />
      </span>
      {title}
    </button>
  );
}

/** Silme Butonunu İfade Eder */
export function DeleteButton({ path, title, method }) {
  path = path ?? "General/Trash";

  return (
    <button
      type="button"
      className="btn btn-danger ml-2"
      onClick={method}
    >
      <span className="svg-icon svg-icon-md">
        <SVG src={toAbsoluteUrl("/media/svg/icons/" + path + ".svg")} />
      </span>
      {title}
    </button>
  );
}

/** */
export function CustomSelect({
  isMulti,
  options,
  value,
  placeholder,
  onBlur,
  onFocus,
  onChange,
  onInputChange
}) {
  options = options ?? [];
  const selectedOption = value === null ? null : options.find(option => option && option.value === value);

  return (
    <Select
      isMulti={isMulti}
      options={options}
      value={selectedOption}
      onBlur={onBlur}
      onFocus={onFocus}
      onChange={onChange}
      onInputChange={onInputChange}
      noOptionsMessage={() => "Kayıt Bulunamadı"}
      placeholder={placeholder ? placeholder : "Seçiniz" }
      styles={{ control: styles => ({ ...styles, minWidth: 150 }) }}
    />
  );
}

/** */
export function TermFilter({
  handleSubmit,
  handleBlur,
  handleChange,
  onChange,
  values
}) {
  const onTermChange = (e) => onChange ? onChange(e) : () => {};

  return (
    <div className="form-group row">
      <div className="col-sm-2"></div>
      <label className="form-label col-form-label col-sm-2">
        Dönem
      </label>
      <div className="col-sm-2">
        <input
          type="number" 
          className="form-control"
          min={1}
          value={values.term}
          id="term"
          placeholder="Dönem"
          onBlur={handleBlur}
          onChange={e => {
            handleChange(e);
            handleChange("term2")(e);
            handleSubmit();
            onTermChange(e);
          }}
        />
      </div>
      <div className="col-sm-2">
        <input className="form-control" value={values.term + 1} id="term2" readOnly />
      </div>
    </div>
  );
}